import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../../../AnimationContents';
import { GameLogic } from '../Logic/BlockCardsLogic';
import { BlockCardsModel } from '../Models/BlockCardsModel';
import { ButtonController, IButtonControllerOptions } from './ButtonController';

export class BlockCardsController extends AnimationBaseController {
    $model: BlockCardsModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('BlockCardsController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.CARDS_JSON,
            libraryName: 'block_cards_container',
            childControllers: {
                MoneyController: {
                    instanceName: 'mini_game_block_cards.big_button',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            if (this._gameLogic.sendResults()) {
                                if (this._gameLogic.isComplete()) {
                                    console.log('complete');
                                    this._options.onComplete();
                                }
                            }
                        },
                    },
                },
            },
            modelWatch: {
                isLockedCard: (isLockedCard: string) => {
                    if (isLockedCard === 'lock') {
                        this._updateLockedCard();
                    } else {
                        this.$queue.get('isLocked').addToQueue(0);
                    }
                },
                resultCode: (resultCode: number) => {
                    this.setTextByQuery(
                        `mini_game_block_cards.enter`,
                        `${this.$model.resultCode}`,
                    );
                },
                showHover: (showHover: string) => {
                    if (showHover === 'lock') {
                        this._updateHover();
                    } else {
                        this.$queue.get('rightAnswer').addToQueue(1);
                    }
                },
            },
            queue: {
                isLocked: {
                    condition: time => time > 0.5,
                    action: () => {
                        this._updateLockedCard();
                    },
                },
                rightAnswer: {
                    condition: time => time > 0.5,
                    action: () => {
                        this._updateHover();
                        this._cardsView();
                        this._isDoneCodes();
                    },
                },
            },
        };
    }

    private _updateLockedCard() {
        this.gotoAndStopByQuery(
            'mini_game_block_cards.lock',
            this.$model.isLockedCard,
        );
    }

    private _updateHover() {
        this.gotoAndStopByQuery(
            `mini_game_block_cards.cards.hover`,
            this.$model.showHover,
        );
    }

    private _cardsView(): void {
        this.$model.cards.forEach((item, i) => {
            this.gotoAndStopByQuery('mini_game_block_cards.cards', `${item}`);
        });
    }

    private _isDoneCodes(): void {
        this.$model.doneCodes.forEach((code) => {
            this.gotoAndStopByQuery(
                `mini_game_block_cards.code${code}`,
                'done',
            );
        });
    }

    protected onInitialize(): void {
        this.gotoAndStopByQuery(
            `mini_game_block_cards.cards.hover`,
            this.$model.isLockedCard,
        );

        this.$model.buttons.forEach((model, i) => {
            this.addChildController(
                {
                    instanceName: `mini_game_block_cards.button_${i}`,
                    view: ButtonController,
                    model: model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            if (model.value === 'c') {
                                this._gameLogic.deleteNumber();
                            } else {
                                this._gameLogic.tapOnNumber(model);
                            }
                        },
                    },
                },
                'button_' + i,
            );
        });

        // Code
        this.setTextByQuery(
            `mini_game_block_cards.enter`,
            `${this.$model.resultCode}`,
        );
        this.$model.codes.forEach((code, i) => {
            this.setTextByQuery(
                `mini_game_block_cards.code${i}.code`,
                `${code}`,
            );
        });

        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(Math.min(this._screenWidth / this._width / this._screenScale, this._screenHeight / this._height / this._screenScale));
    }
}
